import img26 from '../libs/images/img26.jpg'
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router"
import { get_fare_quote_resultindex, get_fare_rule_resultindex, showAlertMessage } from "../components/server/api";
import { setFareQuote, setFareRule } from "../redux/global/global.action";

import parse, { domToReact } from 'html-react-parser';
import { Link } from "react-router-dom";
import Loader from "../components/loader/Loader";
import PassengerForm from '../components/passenger/PassengerForm';
import axios from 'axios';
import { set_flight_fare } from './Home';



const moment = require('moment');

const flight_dateTimeFormat = (timestamp,short=false) => {
    if(short){
        return moment(timestamp).format('ddd MMM DD')
    }
    else{ return moment(timestamp).format('ddd MMM DD hh:mm A') }
}

const OriginDestination = (props) => {
    const search_data = useSelector(state => state.global.search_data)
    const flight_data = useSelector(state=>state.global.flights_list)
    const {Segments} = props;
    var duration = 0;
    return (
        <div >
            <div>
                {
                    props.hasOwnProperty("Segments") && Segments.length ? Segments.map((datas)=>{
                        return datas.map((airport)=>{
                            duration += airport.Duration
                            return (
                                <>


                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <h3 class="card-title">{airport.Origin.Airport.AirportName} to {airport.Destination.Airport.AirportName}</h3>
                                        </div>
                                    </div>
                                    <div class="section-block"></div>
                                    <ul class="list-items list-items-2 list-items-flush py-2">
                                        <li class="font-size-15"><span class="w-auto d-block mb-n1"><i class="la la-plane mr-1 font-size-17"></i>Take off</span>{flight_dateTimeFormat(airport.Origin.DepTime)}</li>
                                        <li class="font-size-15"><i class="la la-clock-o mr-1 text-black font-size-17"></i>{airport.Duration} mins</li>
                                        <li class="font-size-15"><span class="w-auto d-block mb-n1"><i class="la la-plane mr-1 font-size-17"></i>Landing</span>{flight_dateTimeFormat(airport.Destination.ArrTime)}</li>
                                    </ul>

                                </>
                            )
                        })
                    }) : ''
                }
                <div class="col-lg-12">
                    <div class="single-feature-titles text-center border-top border-bottom py-3 mb-4">
                        <h3 class="title font-size-15 font-weight-medium">Total flight time:<span class="font-size-13 d-inline-block ml-1 text-gray">{duration} mins</span></h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

const FlightBooking = (props) => {
    const user_id = useSelector(state => state.global.user_id)
    const [loadcircle,setLoadCircle] = useState(0);
    const dispatch = useDispatch();
    const fare_rule = useSelector(state => state.global.fare_rule)
    const fare_quote = useSelector(state => state.global.fare_quote)
    const airlines = useSelector(state => state.global.airlines)
    const parameter = useParams();
    const flight_token = useSelector(state => state.global.flight_token)
    

    const fr_quot = fare_quote.status ? fare_quote.Results : []

    const get_flight_details =async (data) => {
        setLoadCircle(1)
        await get_fare_rule_resultindex(data).then(async (res)=>{
            if(res.status){
                dispatch(setFareRule({
                    ...res
                }))
            }else{
                showAlertMessage('oops',res.message,false,true)
                return
            }
            await get_fare_quote_resultindex(data).then((rs)=>{
                if(rs.status){
                    dispatch(setFareQuote({
                        ...rs
                    }))
                    setLoadCircle(0)
                }
               
            })
            
        })
    }

    // const get_payment_gateway =async (e) => {
    //     e.preventDefault();
    //     alert();
    //     const data = {
    //         TXN_AMOUNT:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? fare_quote.Results.Fare.PublishedFare : 0,
    //         CUST_ID:user_id
    //     }
    //     await axios({
    //         method: 'POST',
    //         url: 'http://139.59.76.223/cab_and_taxi_final/Payment/paytm_redirect',
    //         data: data,
    
    //       }).then((rs)=>rs)
    //     //   e.submit()
    // }
    const get_payment_gateway = () => {

        const params = {
            TXN_AMOUNT:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? fare_quote.Results.Fare.PublishedFare : 0,
            CUST_ID:user_id,
            IsLCC:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('IsLCC') ? fare_quote.Results.IsLCC : false,
            ResultIndex:fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('ResultIndex') ? fare_quote.Results.ResultIndex : '',
            TraceId:fare_quote.status && fare_quote.hasOwnProperty('TraceId') ? fare_quote.TraceId : '',
            TokenId:flight_token.TokenId,
        }
        // console.log((params))
        // alert()
        // return;
        // The rest of this code assumes you are not using a library.
        // It can be made less verbose if you use one.
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = 'http://onstrips.com/onstripwebsite/OnstripIAMadmin/Payment/paytm_redirect';
      
        for (const key in params) {
          if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            hiddenField.name = key;
            hiddenField.value = params[key];
      
            form.appendChild(hiddenField);
          }
        }
      
        document.body.appendChild(form);
        form.submit();
    }
    useEffect(() => {
        get_flight_details(parameter)
    }, [])


    return    loadcircle?<Loader/>:

     (
        <section class="booking-area padding-top-100px padding-bottom-70px">
        <div class="container">
            <div class="row">
                <div class="col-lg-8">
                    <PassengerForm fare_quote={fare_quote} />
                    <div class="form-box">
                        <div class="form-title-wrap">
                            <h3 class="title">Your Card Information</h3>
                        </div>
                        <div class="form-content">
                            <div class="section-tab check-mark-tab text-center pb-4">
                                <ul class="nav nav-tabs justify-content-center" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <span class="nav-link active" style={{cursor:'pointer'}}>
                                            <i class="la la-check icon-element"></i>
                                            <img src="images/payment-img.png" alt="" />
                                            <span class="d-block pt-2">Online Payment</span>
                                        </span>
                                    </li>
                                    {/* <li class="nav-item">
                                        <a class="nav-link" id="paypal-tab" data-toggle="tab" href="#paypal" role="tab" aria-controls="paypal" aria-selected="true">
                                            <i class="la la-check icon-element"></i>
                                            <img src="images/paypal.png" alt="" />
                                            <span class="d-block pt-2">Payment with PayPal</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="payoneer-tab" data-toggle="tab" href="#payoneer" role="tab" aria-controls="payoneer" aria-selected="true">
                                            <i class="la la-check icon-element"></i>
                                            <img src="images/payoneer.png" alt="" />
                                            <span class="d-block pt-2">Payment with payoneer</span>
                                        </a>
                                    </li> */}
                                </ul>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane fade show active" id="credit-card" role="tabpanel" aria-labelledby="credit-card-tab">
                                    <div class="contact-form-action">
                                        {/* <form method="post" onSubmit={get_payment_gateway} > */}
                                            <div class="row">
                                                {/* <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Card Holder Name</label>
                                                        <div class="form-group">
                                                            <span class="la la-credit-card form-icon"></span>
                                                            <input class="form-control" type="text" name="text" placeholder="Card holder name" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Card Number</label>
                                                        <div class="form-group">
                                                            <span class="la la-credit-card form-icon"></span>
                                                            <input class="form-control" type="text" name="text" placeholder="Card number" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="row">
                                                        <div class="col-lg-6 responsive-column">
                                                            <div class="input-box">
                                                                <label class="label-text">Expiry Month</label>
                                                                <div class="form-group">
                                                                    <span class="la la-credit-card form-icon"></span>
                                                                    <input class="form-control" type="text" name="text" placeholder="MM" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 responsive-column">
                                                            <div class="input-box">
                                                                <label class="label-text">Expiry Year</label>
                                                                <div class="form-group">
                                                                    <span class="la la-credit-card form-icon"></span>
                                                                    <input class="form-control" type="text" name="text" placeholder="YY" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6">
                                                    <div class="input-box">
                                                        <label class="label-text">CVV</label>
                                                        <div class="form-group">
                                                            <span class="la la-pencil form-icon"></span>
                                                            <input class="form-control" type="text" name="text" placeholder="CVV" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="input-box">
                                                        <div class="form-group">
                                                            <div class="custom-checkbox">
                                                                <input type="checkbox" id="agreechb" />
                                                                <label for="agreechb">By continuing, you agree to the <a href="#">Terms and Conditions</a>.</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <input class="form-control" type="hidden" name="CUST_ID" value={user_id} />
                                                <input class="form-control" type="hidden" name="TXN_AMOUNT" value={fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? fare_quote.Results.Fare.PublishedFare : 0} />
                                                
                                                <div class="col-lg-12">
                                                    <div class="btn-box">
                                                        <button class="theme-btn" type="button" onClick={get_payment_gateway}>Confirm Booking</button>
                                                    </div>
                                                </div>
                                            </div>
                                        {/* </form> */}
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="paypal" role="tabpanel" aria-labelledby="paypal-tab">
                                    <div class="contact-form-action">
                                        <form method="post">
                                            <div class="row">
                                                <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Email Address</label>
                                                        <div class="form-group">
                                                            <span class="la la-envelope form-icon"></span>
                                                            <input class="form-control" type="email" name="email" placeholder="Enter email address" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Password</label>
                                                        <div class="form-group">
                                                            <span class="la la-lock form-icon"></span>
                                                            <input class="form-control" type="text" name="text" placeholder="Enter password" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="btn-box">
                                                        <button class="theme-btn" type="submit">Login Account</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="payoneer" role="tabpanel" aria-labelledby="payoneer-tab">
                                    <div class="contact-form-action">
                                        <form method="post">
                                            <div class="row">
                                                <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Email Address</label>
                                                        <div class="form-group">
                                                            <span class="la la-envelope form-icon"></span>
                                                            <input class="form-control" type="email" name="email" placeholder="Enter email address" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 responsive-column">
                                                    <div class="input-box">
                                                        <label class="label-text">Password</label>
                                                        <div class="form-group">
                                                            <span class="la la-lock form-icon"></span>
                                                            <input class="form-control" type="text" name="text" placeholder="Enter password" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-12">
                                                    <div class="btn-box">
                                                        <button class="theme-btn" type="submit">Login Account</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-box booking-detail-form">
                        <div class="form-title-wrap">
                            <h3 class="title">Booking Details</h3>
                        </div>
                        <div class="form-content">
                            <div class="card-item shadow-none radius-none mb-0">
                                <div class="card-img pb-4">
                                    {/* <a href="#" class="d-block">
                                        <img src={img26} alt="plane-img" />
                                    </a> */}
                                </div>
                                <div class="card-body p-0">
                                <OriginDestination {...fr_quot} />
                                    <h3 class="card-title pb-3">Order Details</h3>
                                    <div class="section-block"></div>
                                    <ul class="list-items list-items-2 py-3">
                                        {/* <li><span>Airline:</span>Delta</li> */}
                                        <li><span>Flight Type:</span>Economy</li>
                                        <li><span>Total Price:</span>₹{fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? set_flight_fare(fare_quote.Results.Fare,fare_quote.AirlineCode,airlines) : 0}</li>
                                        {/* <li><span>Base Fare:</span>₹{fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? fare_quote.Results.Fare.BaseFare : 0}</li> */}
                                        {/* <li><spans>Passengers:</span>1</li> */}
                                    </ul>
                                    <div class="section-block"></div>
                                    {/* <ul class="list-items list-items-2 pt-3">
                                        <li><span>Sub Total:</span>₹{fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? fare_quote.Results.Fare.BaseFare : 0}</li>
                                        <li><span>Taxes And Fees:</span>₹0</li>
                                        <li><span>Total Price:</span>₹{fare_quote.status && fare_quote.hasOwnProperty('Results') && fare_quote.Results.hasOwnProperty('Fare') ? set_flight_fare(fare_quote.Results.Fare,fare_quote.AirlineCode,airlines) : 0}</li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
}

export default FlightBooking